// <origin-carousel> — producer image carousel: clip wipe, 5 s auto-advance (paused when hidden / reduced motion), dots, caption.
class OriginCarousel extends HTMLElement {
  connectedCallback() {
    this.i = 0; this.sl = [...this.querySelectorAll('.tq-sl')];
    this.sl.forEach((s) => { const im = s.querySelector('img'); if (!im) return s.remove(); im.addEventListener('error', () => this.drop(s), { once: true }); if (im.complete && !im.naturalWidth && im.currentSrc) this.drop(s); });
    this.sl = this.sl.filter((s) => s.isConnected); this.setup();
  }
  setup() {
    if (this.sl.length < 2) this.querySelector('.tq-car-bar')?.setAttribute('hidden', '');
    if (!this.sl.length) return;
    this.i = 0; const prog = this.querySelector('.tq-car-prog');
    prog.innerHTML = this.sl.map(() => '<i></i>').join(''); this.dots = [...prog.children];
    this.addEventListener('click', (e) => { const b = e.target.closest('[data-step]'); if (b) this.go(this.i + +b.dataset.step, true); });
    this.show(); this.queue();
    document.addEventListener('visibilitychange', () => (document.hidden ? clearTimeout(this.t) : this.queue()));
  }
  drop(s) {
    if (!s.isConnected) return; const wasOn = s.classList.contains('on'); s.remove(); this.sl = this.sl.filter((x) => x !== s); if (!this.sl.length) return;
    const prog = this.querySelector('.tq-car-prog'); prog.innerHTML = this.sl.map(() => '<i></i>').join(''); this.dots = [...prog.children];
    if (this.sl.length < 2) this.querySelector('.tq-car-bar')?.setAttribute('hidden', ''); this.i = Math.min(this.i, this.sl.length - 1); if (wasOn) this.i = 0; this.show();
  }
  disconnectedCallback() { clearTimeout(this.t); }
  queue() { clearTimeout(this.t); if (matchMedia('(prefers-reduced-motion: reduce)').matches || this.sl.length < 2) return; this.t = setTimeout(() => this.go(this.i + 1), 5000); }
  go(i, user) { this.i = (i + this.sl.length) % this.sl.length; this.show(); if (user) this.queue(); else this.queue(); }
  show() {
    this.sl.forEach((s, k) => s.classList.toggle('on', k === this.i)); this.dots.forEach((d, k) => d.classList.toggle('on', k === this.i));
    this.querySelector('.tq-car-n').textContent = `${String(this.i + 1).padStart(2, '0')} / ${String(this.sl.length).padStart(2, '0')}`;
    this.querySelector('.tq-car-cap').textContent = this.sl[this.i].dataset.cap || '';
  }
}
if (!customElements.get('origin-carousel')) customElements.define('origin-carousel', OriginCarousel);
